// ============================================================
// Stats.js - 4 number counters (15+, 500+, 1000+, 24/7)
// ============================================================

import React from "react";
import { STATS } from "../data";

function Stats() {
  return (
    <section className="stats">
      {STATS.map((stat) => (
        <div className="stat-item" key={stat.label}>
          <h3>{stat.value}</h3>
          <p>{stat.label}</p>
        </div>
      ))}
    </section>
  );
}

export default Stats;
